export default __webpack_public_path__ + "static/media/bing.8739402c.svg";